import { useState, useEffect } from 'react'
import { IDeviceType } from './types'

export function useDeviceType(): IDeviceType {
  const [device, setDevice] = useState<IDeviceType>('desktop')

  useEffect(() => {
    const getDeviceType = (): IDeviceType => {
      const width = window.innerWidth
      if (width < 768) return 'mobile'
      if (width < 1100) return 'tablet'
      return 'desktop'
    }

    setDevice(getDeviceType())

    const handleResize = () => setDevice(getDeviceType())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return device
}
